export default class DefaultRoleUnauthenticated {
    constructor(pages, defaultRedirection) {
        this.name = "default";
        this.pages = pages;
        this.defaultRedirection = defaultRedirection;
        this.namedCode = "default";
    }
}